import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";
import {
  onSetLoaded,
  onSetError,
  onSetLoadedCreate,
  onSetLoadedDelete,
  onSetLoadedUpdate,
  onErrorCreate,
  onErrorUpdate,
  onErrorDelete,
  createFailed,
  updateFailed,
  deleteFailed,
} from "./../utils/loadedError";

const deleteRecords = (initialState, data) => {
  switch (data.action) {
    case "restore":
      return initialState.deletedData.filter((item) => item !== data.record);
    case "delete":
      return [...initialState.deletedData, data.record];
    default:
      return initialState.deletedData;
  }
};

function* idMaker() {
  var index = -1;
  while (true) yield index--;
}

let it = idMaker();

const initialPortalUsersState = {
  dataAll: [],
  portals: [],
  portalsIsSet: false,
  dataAllIsSet: false,
  isLoaded: false,
  Error: null,
};

const portalusersSlice = createSlice({
  name: "portalusers",
  initialState: initialPortalUsersState,
  reducers: {
    onClearStore(state) {
      state.dataAll = [];
      state.portals = [];
      state.portalsIsSet = false;
      state.dataAllIsSet = false;
      state.isLoaded = false;
      state.Error = null;
    },

    createStoreByPortals(state, action) {
      let portals = action.payload;
      portals.forEach((portal) => {
        state[portal.id] = {
          data: [],
          changedData: [],
          deletedData: [],
        };
      });
      state.portals = portals;
      state.portalsIsSet = true;
    },

    onInitialPortalUsers(state, action) {
      state.dataAll = action.payload;
      state.dataAllIsSet = true;
      state.isLoaded = true;
      state.Error = null;
      state.isLoadedCreate = true;
      state.isLoadedDelete = true;
      state.isLoadedUpdate = true;
      state.errorCreate = null;
      state.errorDelete = null;
      state.errorUpdate = null;
    },

    onSetDataByPortal(state, action) {
      const [portalId, newData] = action.payload;
      newData.forEach((newItem) => {
        const existingIndex = state[portalId].data.findIndex((item) => item.id === newItem.id);
        if (existingIndex === -1) {
          state[portalId].data.push(newItem);
          state[portalId].changedData.push(newItem);
        } else {
        }
      });
      state[portalId].deletedData = [];
    },

    onSetDataByPortals(state, action) {
      let dataAll = state.dataAll;
      state.portals.forEach((portal) => {
        state[portal.id].data = dataAll.filter((item) => item.portal_id === portal.id);
        state[portal.id].changedData = dataAll.filter((item) => item.portal_id === portal.id);
        state[portal.id].deletedData = [];
      });
    },
    onSetLoaded,
    onSetError,
    onSetLoadedCreate,
    onSetLoadedUpdate,
    onSetLoadedDelete,
    onErrorCreate,
    onErrorUpdate,
    onErrorDelete,
    createFailed,
    updateFailed,
    deleteFailed,

    deleteDataSuccess(state, action) {
      let id = action.payload.data;
      let portalId = action.payload.portalId;
      state[portalId].data = state[portalId].data.filter((item) => item.id !== id);
      state[portalId].changedData = state[portalId].changedData.filter((item) => item.id !== id);
      state[portalId].deletedData = state[portalId].deletedData.filter((item) => item !== id);
    },

    updateDataSuccess(state, action) {
      let data = action.payload.data;
      let portalId = action.payload.portalId;
      state[portalId].data = state[portalId].data.map((item) => (item.id === data.id ? data : item));
      state[portalId].changedData = state[portalId].changedData.map((item) => (item.id === data.id ? data : item));
      state.isLoadedUpdate = true;
    },

    createDataSuccess(state, action) {
      let data = action.payload.data;
      let oldId = action.payload.oldId;
      let portalId = action.payload.portalId;
      state[portalId].data = [...state[portalId].data, data];
      state[portalId].changedData = state[portalId].changedData.map((item) => (item.id === oldId ? data : item));
      state.isLoadedCreate = true;
    },

    changeData(state, action) {
      const record = action.payload.record;
      const property = action.payload.property;
      const portalId = action.payload.portalId;
      state[portalId].changedData = state[portalId].changedData.map((item) =>
        item.id === record.id ? { ...item, [property]: record[property] } : item,
      );
    },

    deleteData(state, action) {
      const Id = action.payload.record;
      const isNew = action.payload.isNew;
      const portalId = action.payload.portalId;
      if (!isNew) {
        state[portalId].deletedData = [...deleteRecords(state[portalId], action.payload)];
      } else {
        state[portalId].changedData = state[portalId].changedData.filter((item) => item.id !== Id);
      }
      state.isLoadedDelete = true;
    },

    deleteDataFirst(state, action) {
      let portalId = action.payload;
      state[portalId].changedData = state[portalId].changedData.slice(1);
    },

    createData(state, action) {
      let { portalId, customer, portalName } = action.payload;
      let newRecord = {
        id: it.next().value,
        portal_id: portalId,
        customer_id: customer,
        full_name: "",
        login: "",
        password: "",
        email: "",
        organization: "",
        position: "",
        phone: "",
        isNew: true,
      };

      state[portalId].changedData = [newRecord, ...state[portalId].changedData];
    },
  },
});

export const portalusersActions = portalusersSlice.actions;
export default portalusersSlice.reducer;
